import { Auth0Error } from 'auth0-js';
import { useCallback } from 'react';
import { ErrorOption } from 'react-hook-form/dist/types/errors';

import { ISimpleSignupData } from '../../common/UiSignup';

export default function useSignupError(setParentError: (name: keyof ISimpleSignupData, error: ErrorOption) => void) {
    return useCallback(
        (error: Auth0Error | null) => {
            let errorCode = 'defaultError';

            switch (error?.code) {
                case 'user_exists':
                    errorCode = 'userExists';
                    break;
                case 'server_error':
                case 'extensibility_error':
                    errorCode = 'useSso';
                    break;
                default: break;
            }

            setParentError('email', { type: errorCode });
        },
        [ setParentError ],
    );
}
